import React from "react";
import { component_tool } from "@/tool";
import RoleUserAddList from "./roleUserAdd/roleUserAddList";
let { WizModal } = component_tool;

//配置项
const componentName = "roleUser";
let ref;
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "账号",
    name: "userName",
    dataIndex: "userName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "姓名",
    name: "fullName",
    dataIndex: "fullName",
    searchItem: {},
    tableItem: {}
  },
  {
    title: "账号状态",
    name: "state",
    dataIndex: "state",
    tableItem: {},
    searchItem: { type: 'select',},
    dict: [
      { code: 1, codeName: "激活" },
      { code: 0, codeName: "禁用" }

    ]
  }
];

const templateConfig = (data)=>{
  const {roleId} = data;
  return {
    mainProps: {},
    content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort:['addPeople',"delete"],
        buttons: [
          {
            key: "addPeople",
            custom: true,
            params: { children: "添加人员", type: "info" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "选择人员",
                  diy: (e) => (
                    <RoleUserAddList
                      {...e} roleId={roleId} key={new Date()}
                      ref={r => {
                        ref = r && r.getWrappedInstance();
                      }}
                    />
                  ),
                  onOk: () => {
                    ref._ok(data);
                  },
                  width: 1000
                }
              }
            }
          }
          // ,
          // {
          //   key: "delete",
          //   custom: true,
          //   needSelect: true,
          //   params: { children: "删除", type:'danger' },
          //   customOnClick: {
          //     key: "action",
          //     params: {
          //       apiKey: "delete",
          //       apiParams: {}
          //     },
          //     formatParams: (rows, record, filters, callback) => {
          //       let ids = [];
          //       rows.forEach(row => {
          //         ids.push(row.id);
          //       });
          //       const content = "您确定要删除吗?";
          //       WizModal.confirm({
          //         title: "注意",
          //         content,
          //         onOk: () => {
          //           callback &&
          //             callback({
          //               ids: ids,
          //               ...filters
          //             });
          //         },
          //         onCancel() {}
          //       });
          //       return null;
          //     }
          //   }
          // }
        ]
      },
      modalFormProps: {},
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        loading: false
      },
      commonOperate: {
        //   add: true,
        //   delete: true
      }
    }
  }
  }
};



let reduxTemplateCofig = args => {
  const {roleId} = args;
  const apis = {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: {roleId:roleId}
      }
    },
    add: {
      path: `${componentName}/add`,
      payload: {
        key: `${componentName}@add`,
        apiParams: {}
      }
    },
    delete: {
      path: `${componentName}/delete`,
      payload: {
        key: `${componentName}@delete`,
        apiParams: {}
      }
    }
  };

  return {
    apis,
    componentName,
    initApiKeys: ["list"],
    keepInitApiParams:true,
    needLoading: true,
    ...args
  };
};

export { reduxTemplateCofig, templateConfig };
